/**
 * Helper: Product
 * -----------------------------------------------------------------------------
 * Common product and variant logic.
 * - Add in alphabetical order.
 *
 */

/**
 * Check if there is an available variant with the given option value.
 * @param {Object} product - The formatted GraphQL product response.
 * @param {String|String[]} optionValue - The option value or an array of
 * values.
 * @returns {boolean}
 */
 export function isVariantOptionAvailable(product, optionValue) {
  if (!product) {
    return true
  }

  let options = []

  if (typeof optionValue === 'string') {
    options.push(optionValue)
  }
  else if (Array.isArray(optionValue)) {
    options = optionValue.filter(Boolean)
  }

  return product.variants.filter(variant => {
    const valuesAreInSelectedOptions = options.every(value => {
      return variant.selectedOptions.some(option =>
        option.value.toLowerCase() === value.toLowerCase(),
      )
    })

    return valuesAreInSelectedOptions && variant.available
  }).length > 0
}

